// /features/juegoFechas/constants/diasSemana.ts
export enum DiasSemana {
  DOMINGO = 0,
  LUNES = 1,
  MARTES = 2,
  MIERCOLES = 3,
  JUEVES = 4,
  VIERNES = 5,
  SABADO = 6,
}

export interface PreguntaFecha {
  fecha: Date;
  opcionCorrecta: DiasSemana;
  inputUsuario: DiasSemana | null;
}

export const diasArray = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];